import {Laboratoire} from '../api/Laboratoire';
import {PersonneResponsable, PersonneResponsableInterface} from '../api/PersonneResponsable';
import {Personne, PersonneInterface} from '../api/Personne';

export class ExLaboratoire extends Laboratoire {
    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }

        this.directeurDivision = new PersonneResponsable(this.directeurDivision as PersonneResponsableInterface);
        this.directeurDivision.personne = new Personne(
            this.directeurDivision.personne as PersonneInterface
        );
    }
}
